/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Fri Jul 29 2022
*  File : ModuleLoader.ts
*******************************************/




import { ClientSdkCorePublic } from "@api-commons/sdk/ClientSdkPublicInterface.js";
import { PushServiceInterface } from "@api-commons/subscriptions/PushServiceInterface.js";
import { GuiController } from "@personal-area/gui/GuiController.js";

import { AbstractModuleLoader } from '@personal-area/modularization/AbstractModuleLoader.js';

import { CookistGuiController } from "../gui/CookistGuiController.js";
import { CatalogueLanguages } from "@ciaopeople/cp-shatsu/Catalogue";


export class CookistModuleLoader extends AbstractModuleLoader {
    
    public getGui(): Promise<CookistGuiController> {
        return super.getGui().then(
            g => g as CookistGuiController
        );
    }

    protected initSdkClient(): Promise<ClientSdkCorePublic> {
        return import(/* webpackChunkName: "cookist/com/pa/sdk-client" */ "./modules/ClientLightweight.js").then(
            ({ SdkClient }) => {
                return SdkClient(this.configHelper.getOriginal(), this);
            }
             
        );
    }

    protected initSdkServer(): Promise<any> {
        return this.injectScript(this.configHelper.getSdkJsServerUrl(), "fp-sdk-server");
    }

    protected initPushHelper(): Promise<PushServiceInterface> {
        return this.getSdkClient().then(
            (sdk) => {
                return sdk.pushNotificationService;
            }
        );
    }


    protected initGui(): Promise<GuiController> {
        const proms = [
            
        ];

        return this.getSdkClient().then(
           sdk => {
                const gui = import(/* webpackChunkName: "cookist/com/pa/gui" */ './modules/GUI.js');
                
                return gui.then(
                    ({ GUI }) => {
                        return GUI(
                            this.win,
                            sdk,
                            CatalogueLanguages.en
                        );
                    }
                );

            }
        );
    }


}